"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
function fullParse(json) {
    try {
        var parsed = JSON.parse(json);
        return fullParse(parsed);
    }
    catch (error) {
        return json;
    }
}
exports.fullParse = fullParse;
function multilingualToString(multilingualString) {
    if (!multilingualString) {
        return '';
    }
    var obj = {};
    multilingualString.toMap().forEach(function (value, key) {
        obj[key] = value;
    });
    return JSON.stringify(obj);
}
exports.multilingualToString = multilingualToString;
function stringToMultilingual(json) {
    if (json === '') {
        return undefined;
    }
    var multilingualString = JSON.parse(json);
    var builder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
    for (var key in multilingualString) {
        if (multilingualString.hasOwnProperty(key)) {
            builder.withValueForLanguage(+key, multilingualString[key]);
        }
    }
    return builder.build();
}
exports.stringToMultilingual = stringToMultilingual;
// Decorator
// tslint:disable:no-any
// tslint:disable:no-invalid-this
function CoolDown(ms) {
    var enabled = true;
    return function (target, propertyKey, descriptor) {
        var method = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (enabled) {
                enabled = false;
                setTimeout(function () { return (enabled = true); }, ms);
                return method.apply(this, args);
            }
        };
    };
}
exports.CoolDown = CoolDown;
function createLogger(scope) {
    return new skynet_store_utilities_1.Logger('idm-dynamic-forms-controls', scope);
}
exports.createLogger = createLogger;
//# sourceMappingURL=utilities.js.map